/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProviderComponentUsageDetails } from './providerComponentUsageDetails';


export interface ProviderComponentUsage { 
    /**
     * Reporting agent identifier
     */
    agent_id?: string;
    components?: Array<ProviderComponentUsageDetails>;
    /**
     * Job identifier. This will contains the job id when payload is requested from provider.
     */
    job_id?: string;
    peer_components?: Array<ProviderComponentUsageDetails>;
    /**
     * Report time for inventory usage
     */
    report_time?: Date;
}

